import React from 'react';
import styled from 'styled-components';
import ChatIcon from '@mui/icons-material/Chat';
import { Background, Border, Text } from 'styles/themeColors';
import { Space } from 'styles/themeSpaces';
import Comment from 'data/Comment';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Space.sp2x};
  width: 100%;
  padding: ${Space.sp2x} ${Space.sp3x};
  background-color: ${Background.shaded};
  border: 1px solid ${Border.light};
  border-radius: 8px;
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  color: ${Text.secondary};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
`;

const CommentItem = styled.div`
  & + & {
    margin-top: ${Space.spBasePlus};
    padding-top: ${Space.spBasePlus};
    border-top: 1px solid ${Border.light};
  }
`;

const CommentLabel = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${Text.primary};
`;

const CommentText = styled.p`
  margin: ${Space.spHalf} 0 0;
  font-size: 14px;
  line-height: 20px;
  color: ${Text.secondary};
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: break-word;
`;

const toTitleCase = (value: string): string =>
  value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : '';

interface Props {
  comments: Comment[];
}

const ConsignmentEntryComments: React.FC<Props> = ({ comments }) => {
  if (!comments || comments.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      <IconWrapper>
        <ChatIcon style={{ fontSize: 28 }} />
      </IconWrapper>
      <Content>
        {comments.map(comment => (
          <CommentItem key={comment.id}>
            <CommentLabel>{`${toTitleCase(comment?.initiatedBy)} Comment`}</CommentLabel>
            <CommentText>{comment.comment}</CommentText>
          </CommentItem>
        ))}
      </Content>
    </Wrapper>
  );
};

export default React.memo(ConsignmentEntryComments);
